import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiMeta } from '../../_core/_model/api-response';
import { AdminKycApplicationListItemDto } from '../../_core/_model/compliance';
import { ComplianceApiService } from '../../_core/_services/_compliance/compliance-api.service';
import { NotificationService } from '../../_core/_services/notification.service';
import { ComplianceAdminService } from '../../_core/_services/_compliance/compliance-admin.service';

@Component({
  selector: 'app-admin-kyc-reviews',
  standalone: false,
  templateUrl: './admin-kyc-reviews.html',
  styleUrl: './admin-kyc-reviews.css',
})
export class AdminKycReviews implements OnInit {
  loading = false;
  items: AdminKycApplicationListItemDto[] = [];
  meta: ApiMeta | null = null;
  filter = {
    status: '',
    jurisdictionCode: '',
    tierCode: '',
    customerType: '',
    productType: '',
    search: '',
    page: 1,
    pageSize: 20,
  };

  jurisdictions: any[] = [];
  customerTypes: any[] = [];
  productTypes: any[] = [];
  tierCodes: any[] = [];
  statuses: any[] = [];

  constructor(
    private api: ComplianceApiService,
    private notify: NotificationService,
    private route: ActivatedRoute,
    private router: Router,
    private complianceAdminService: ComplianceAdminService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.filter.page = +(params['page'] || 1);
      this.load();
    });

    this.customerTypes = this.complianceAdminService.getCustomerTypes();
    this.productTypes = this.complianceAdminService.getProductTypes();
    this.tierCodes = this.complianceAdminService.getTierCodes();
    this.statuses = this.complianceAdminService.getPolicyStatuses();
    this.loadJurisdictions();
  }

  loadJurisdictions(): void {
    this.complianceAdminService.getJurisdictions({ page: 1, pageSize: 200 }).subscribe({
      next: (res) => this.jurisdictions = res?.data || []
    });
  }

  load(): void {
    this.loading = true;
    this.api.getAdminReviews(this.filter).subscribe({
      next: (res) => {
        this.items = res.data || [];
        this.meta = res.meta;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.notify.showError(err?.error?.error?.details || err?.error?.message || 'Unable to fetch KYC reviews.', 'Compliance');
      }
    });
  }

  startReview(item: AdminKycApplicationListItemDto): void {
    this.api.startReview(item.applicationId, 'Started from admin queue').subscribe({
      next: (res) => {
        this.notify.showSuccess(res.message || 'Application moved to under review.', 'Compliance');
        this.load();
      },
      error: (err) => this.notify.showError(err?.error?.error?.details || err?.error?.message || 'Unable to start review.', 'Compliance')
    });
  }

  approve(item: AdminKycApplicationListItemDto): void {
    this.api.approveApplication(item.applicationId, 'Approved from admin queue').subscribe({
      next: (res) => {
        this.notify.showSuccess(res.message || 'Application approved.', 'Compliance');
        this.load();
      },
      error: (err) => this.notify.showError(err?.error?.error?.details || err?.error?.message || 'Unable to approve application.', 'Compliance')
    });
  }

  reject(item: AdminKycApplicationListItemDto): void {
    const reason = window.prompt('Enter rejection reason');
    if (!reason) return;
    this.api.rejectApplication(item.applicationId, reason).subscribe({
      next: (res) => {
        this.notify.showSuccess(res.message || 'Application rejected.', 'Compliance');
        this.load();
      },
      error: (err) => this.notify.showError(err?.error?.error?.details || err?.error?.message || 'Unable to reject application.', 'Compliance')
    });
  }

  open(item: AdminKycApplicationListItemDto): void {
    this.router.navigate(['/admin/compliance/reviews', item.applicationId]);
  }
}
